import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import AirlineImg from 'components/AirlineLogo';

interface FlightColumnProps {
  right?: boolean;
}

interface InfoProps {
  gray?: boolean;
}

export const Container = styled.div`
  position: relative;
`;

export const FlightSection = styled.section`
  margin: 10px 0;
`;

export const FlightCard: any = styled.div`
  border-radius: 8px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  background: ${ColorPalette.HEX.White};
`;

FlightCard.Body = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 33.3%);
  align-items: center;
  padding: 15px;
`;

FlightCard.Header = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 15px 0 15px;
`;

export const AirlineLogo = styled(AirlineImg)`
  max-width: 24px;
  max-height: 24px;
`;

export const AirlineName = styled.h5`
  margin-left: 10px;
  font-weight: 600;
  font-size: 16px;
`;

export const FlightNumber = styled.span`
  font-size: 12px;
  text-align: right;
  margin-left: auto;
  text-align: right;
  color: ${({ theme }) => theme.flightSector.secondary};
`;

export const OperatorName = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.Manatee};
  margin-top: 2px;
  margin-left: 15px;
`;

export const FlightColumn = styled.div<FlightColumnProps>`
  text-align: ${({ right }) => (right ? 'right' : 'left')};
  min-height: 164px;
`;

export const FlightTitle = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const FlightDate = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const FlightTime = styled.h2`
  position: relative;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  word-break: keep-all;
  color: ${ColorPalette.HEX.PineTree};
`;

export const FlightTimeTurnDays = styled.h2`
  position: absolute;
  right: -20px;
  top: -10px;
  width: 20px;
  font-size: 10px;
  text-align: left;
  font-weight: 600;
  line-height: 24px;
  word-break: keep-all;
  color: ${ColorPalette.HEX.PineTree};
`;

export const FlightAirportInitials = styled.h5`
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  font-size: 16px;
  margin-top: 10px;
`;

export const FlightAirportCity = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const FlightAirportName = styled.span`
  font-size: 10px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const FlightLineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`;

export const FlightLineTopText = styled.span`
  color: ${ColorPalette.HEX.PineTree};
  font-size: 12px;
  line-height: 14px;
  margin: 5px 0;
`;

export const FlightLineBottomText = styled.span`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 10px;

  & > span {
    text-transform: capitalize;
  }
`;

export const FlightLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin: 5px 0;
  width: 100%;
  height: 2px;
  background: ${({ theme }) => theme.flightLine.line};

  &:before,
  &:after {
    content: '';
    height: 4px;
    width: 4px;
    border-radius: 4px;
    background: ${ColorPalette.HEX.White};
    border: 2px solid ${({ theme }) => theme.flightLine.point};
  }
`;

export const Info: any = styled.div<InfoProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  padding: 10px;
  border-radius: 8px;
  background-color: ${({ gray }) =>
    gray ? 'rgba(229, 237, 239, 0.5)' : `rgba(${ColorPalette.RGB.BrightOrange}, 0.05)`};
`;

Info.Time = styled.img`
  margin-right: 10px;
`;

Info.Message = styled.span<InfoProps>`
  font-size: 10px;
  color: ${({ gray }) => (gray ? ColorPalette.HEX.DimGray2 : ColorPalette.HEX.BrightOrange)};

  & > strong {
    font-weight: 600;
  }
`;
